
export default {
    data() {
        return {
            isExpanded: false
        }
    },
};
